// Function that will wait until an element has finished loading. This is needed as the element is loaded via an app so we cannot gaurantee when it will load
function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
      var startTimeInMs = Date.now();
      (function loopSearch() {
        if (document.querySelector(selector) != null) {
          callback();
          return;
        }
        else {
          setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs)
              return;
            loopSearch();
          }, checkFrequencyInMs);
        }
      })();
    }

    function setCookie(key, value, expiry) {
      var expires = new Date();
      expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
      document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
    }

    function getCookie(key) {
      var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
      return keyValue ? keyValue[2] : null;
    }

  waitForElementToDisplay("#onetrust-consent-sdk", () => {

  let oneTrustContainer = document.querySelector('#onetrust-consent-sdk');
  let oneTrustFloatingBtn = document.querySelector('#ot-sdk-btn-floating');

    // Here we check if the cookie has already been set by getting it via it's name
  if (getCookie('siteCookieSettings') == 'true') {
    // Cookie already set so hide the cookie elements and return
    oneTrustContainer.classList.add('hidden');
    oneTrustContainer.classList.remove('block-important');
    oneTrustContainer.classList.add('pointer-events-none');
    oneTrustFloatingBtn.classList.add('hidden');
    oneTrustFloatingBtn.classList.add('pointer-events-none');
  return;
    // We set the cookie to display 'none' by default so that it doesn't show until we know they haven't checked it before
    // If the cookie cannot be found, we override the display by calling this new class created to override the default and show it
  } else {
        oneTrustContainer.classList.add('block-important');
  }
  
  let oneTrustRefuseInSettings = document.querySelector('.ot-pc-refuse-all-handler');
  let oneTrustAcceptInSettings = document.querySelector('#accept-recommended-btn-handler');
  let oneTrustConfirmInSettings = document.querySelector('.save-preference-btn-handler');

  let oneTrustRefuseInBottom = document.querySelector('#onetrust-reject-all-handler');
  let oneTrustAcceptInBottom = document.querySelector('#onetrust-accept-btn-handler');

    // add click event listeners to all of the accept and refuse cookie buttons so once pressed, we set the cookie and apply the styles to remove the cookie elements for the page
  [oneTrustRefuseInSettings, oneTrustAcceptInSettings, oneTrustConfirmInSettings, oneTrustRefuseInBottom, oneTrustAcceptInBottom].forEach(function(element) {
   element.addEventListener("click", (e) => {
      setCookie('siteCookieSettings', 'true', 100);
      oneTrustContainer.classList.remove('block-important');
      oneTrustContainer.classList.add('pointer-events-none');
      oneTrustFloatingBtn.classList.add('hidden');
      oneTrustFloatingBtn.classList.add('pointer-events-none');
   });
});
},300,10000);